export const fetchfilter = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/get-attributes/`);
    if (!response.ok) {
      throw new Error('Failed to fetch brands');
    }
    const data = await response.json();
    return data;
    // Extract brand_name from each brand_details object
    //return data.map(item => item.brand_details.brand_name);
  } catch (error) {
    throw new Error(`API Error: ${error.message}`);
  }
};

export const fetchfilterproduct = async (filters = {}, searchTerm = '') => {
  try {
    const parts = [];

    // Categories → IDs
    if (filters.categories?.length) {
      const categoryIds = filters.categories.map(cat =>
        typeof cat === "object" ? cat.category_id : cat
      );
      parts.push(`category_id=${categoryIds.join(",")}`);
    }

    // Brands → IDs
    if (filters.brands?.length) {
      const brandIds = filters.brands.map(b =>
        typeof b === "object" ? b.brand_id : b
      );
      parts.push(`brand_id=${brandIds.join(",")}`);
    }

    // Colors → codes
    if (filters.colors?.length) {
      const colorCodes = filters.colors.map(c =>
        typeof c === "object" ? c.code : c
      );
      parts.push(`color=${colorCodes.map(code => encodeURIComponent(code)).join(",")}`);
    }
    
    // Sizes → codes
    if (filters.sizes?.length) {
      const sizeCodes = filters.sizes.map(s =>
        typeof s === "object" ? s.code : s
      );
      parts.push(`size=${sizeCodes.join(",")}`);
    }

    // Search term
    if (searchTerm) {
      parts.push(`search=${encodeURIComponent(searchTerm)}`);
    }

    const queryString = parts.join("&");
    const url = `${process.env.REACT_APP_API_BASE_URL}/filter-products/?${queryString}`;

    const response = await fetch(url);
    if (!response.ok) throw new Error("Failed to fetch filtered products");

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(`API Error: ${error.message}`);
  }
};